<template>
    <main class="max-w-5xl m-5 w-full" :class="{ loading }">
        <meeting-printable-report-attendance />
        <meeting-printable-report-description
            v-if="meeting.showDescription && meeting.description && meeting.description.trim().length > 0"
        />
        <meeting-printable-report-companies v-if="meeting.showParticipantsIndex" />
        <meeting-printable-report-photos-page v-if="meeting.showGeneralProgress && meeting.attachments.length > 0" />
        <meeting-printable-report-planning-page v-if="meeting.showPlanning && hasTasks" />
        <meeting-printable-report-generals-page v-if="meeting.showGeneralObservations && hasGeneralObservations" />
        <meeting-printable-report-penalties-page v-if="meeting.showPenaltiesTable" />
        <meeting-printable-report-amendments-page v-if="meeting.showAmendmentsTable" />
        <meeting-printable-report-task-table-page v-if="meeting.showTasksTable && hasTasks" />
        <template v-for="bundle in bundles">
            <meeting-printable-report-bundle-page :bundle="bundle" :bundlesData="bundlesData" />
        </template>
    </main>
</template>

<script>
import MeetingPrintableReport from '@/features/meetings/MeetingPrintableReportCompanies';
import MeetingPrintableReportCompanies from '@/features/meetings/MeetingPrintableReportCompanies';
import MeetingPrintableReportPhotosPage from '@/features/meetings/MeetingPrintableReportPhotosPage';
import MeetingPrintableReportTaskTablePage from '@/features/meetings/MeetingPrintableReportTaskTablePage';
import { getMeeting } from '@/features/meetings/meetings.service';
import MeetingPrintableReportPlanningPage from '@/features/meetings/MeetingPrintableReportPlanningPage';
import MeetingPrintableReportBundlePage from '@/features/meetings/MeetingPrintableReportBundlePage';
import MeetingPrintableReportGeneralsPage from '@/features/meetings/MeetingPrintableReportGeneralsPage';
import { bundlesToGroups, getBundles } from '@/features/bundles/bundles.service';
import MeetingPrintableReportAttendance from '@/features/meetings/MeetingPrintableReportAttendance';
import { getMapById, sortBy } from '@/services/sanitize.service';
import { combineLatest } from 'rxjs';
import { getCompanies } from '@/features/companies/companies.service';
import { getTasks } from '@/features/tasks/tasks.service';
import { getGeneralObservations } from '@/features/observations/observation.service';
import MeetingPrintableReportDescription from '@/features/meetings/MeetingPrintableReportDescription.vue';
import MeetingPrintableReportPenaltiesPage from '@/features/meetings/MeetingPrintableReportPenaltiesPage.vue';
import MeetingPrintableReportAmendmentsPage from '@/features/meetings/MeetingPrintableReportAmendmentsPage.vue';
import { getByBundleData } from '@/features/meetings/byBundle.service';
export default {
    async created() {
        this.subscriptions = [
            getMeeting(this.$route.params.projectId, this.$route.params.meetingId).subscribe(
                (meeting) => (this.meeting = meeting),
            ),
            combineLatest([
                getBundles(this.$route.params.projectId),
                getCompanies(this.$route.params.projectId),
                getTasks(this.$route.params.projectId),
                getGeneralObservations(this.$route.params.projectId),
                getByBundleData(this.$route.params.projectId),
            ]).subscribe(([bundles, companies, tasks, generalObservations, bundlesData]) => {
                this.bundlesData = bundlesData;
                this.hasTasks = tasks.length > 0;
                this.hasGeneralObservations = generalObservations.length > 0;
                const companyMap = getMapById(companies);
                const bundlesByGroup = bundlesToGroups(
                    sortBy(
                        bundles.map((bundle) => {
                            bundle.company = companyMap[bundle.companyId];
                            return bundle;
                        }),
                        'reference',
                    ),
                );
                this.bundles = [
                    ...bundlesByGroup.MOA,
                    ...bundlesByGroup.AMOA,
                    ...bundlesByGroup.MOE,
                    ...bundlesByGroup.company,
                    ...bundlesByGroup.distributor,
                ];
                this.$nextTick(() => (this.loading = false));
            }),
        ];
    },
    data() {
        return {
            meeting: {},
            bundles: [],
            bundlesData: [],
            subscriptions: [],
            loading: true,
            hasTasks: false,
            hasGeneralObservations: false,
        };
    },
    components: {
        MeetingPrintableReportAmendmentsPage,
        MeetingPrintableReportPenaltiesPage,
        MeetingPrintableReportDescription,
        MeetingPrintableReportAttendance,
        MeetingPrintableReportGeneralsPage,
        MeetingPrintableReportBundlePage,
        MeetingPrintableReportPlanningPage,
        MeetingPrintableReportTaskTablePage,
        MeetingPrintableReportPhotosPage,
        MeetingPrintableReportCompanies,
        MeetingPrintableReport,
    },
};
</script>
